export const CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES = [
  'EVENT_ELECTRIC_METER_ORDER',
  'SITE_ELECTRIC_METER_ORDER',
];
